module.exports = __webpack_public_path__ + "img/A-new-take-on-vegan-1-1.fb2621af.png";